import { SidePanel, TextArea } from '@getsynapse/design-system';
import React, { useEffect, useState } from 'react';
import intl from 'react-intl-universal';

export type Props = {
  open: boolean;
  onNoteSaved: (data: any) => void;
  onClose: () => void;
  title: string;
  note: string;
};

const NoteSidePanel: React.FC<Props> = ({
  open,
  onClose,
  title,
  note,
  onNoteSaved,
}) => {
  const [updatedNote, setUpdatedNote] = useState<string>('');
  useEffect(() => {
    setUpdatedNote(note ?? '');
  }, [note, open]);

  const handleSave = () => {
    onNoteSaved(updatedNote);
  };

  return (
    <>
      <SidePanel
        headerElement={<div className='font-bold'>{title}</div>}
        footerButtons={[
          {
            children: intl.get('BUDGET_PAGE.CREATE_BUDGET_MODAL.SUBMIT'),
            'data-cy': 'task-side-panel__update-button',

            onClick: handleSave,
          },
          {
            children: intl.get('SIDE_PANEL.CANCEL_BUTTON'),
            variant: 'tertiary',
            onClick: onClose,
          },
        ]}
        isOpen={open}
        onClose={onClose}
      >
        <div className='flex flex-col gap-y-4'>
          <h1 className='font-bold'>{intl.get('BUDGET_PAGE.EDIT.NOTES')}</h1>
          <TextArea
            textAreaProps={{
              className: 'w-full h-100',
              placeholder: intl.get('BUDGET_PAGE.EDIT.NOTE_PLACEHOLDER'),
            }}
            value={updatedNote}
            onChange={(event) => setUpdatedNote(event.target.value)}
          />
        </div>
      </SidePanel>
    </>
  );
};

export default NoteSidePanel;
